import { Injectable } from "@angular/core";
import { ErrorMessageService } from "app/core/error-message.service";
import { ApiService } from "app/shared/security/api-services/api.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Comment } from "../../models/comment";
import { CommentApi } from "./comment-api.models";

@Injectable()
export class CommentApiService extends CommentApi {
  private _endpointPath: string =
    environment.apiHost + "/v1/workorders/comments";

  constructor(
    private apiService: ApiService,
    private errorMessageService: ErrorMessageService,
  ) {
    super();
  }

  public getPredefinedComments() {
    return this.apiService.get<{ items: Comment[] }>(this._endpointPath).pipe(
      map((res) => res.items || []),
      tap(
        (res) => res,
        (error) => this.errorMessageService.notifyError(error),
      ),
    );
  }
}
